<template>
  <div class="content">
    <IntroTitle
      :title="$t('experience.personal-data.title')"
      padding="10px 30px"
      paddingDesktop="20px 50px"
      titleFontSize="1.2rem"
      titleMobileFontSize="1.1rem"
      descriptionAlign="initial"
      descriptionMobileAlign="center"
      effect="top-to-bottom--effect">
    </IntroTitle>
    <div class="form">
      <div class="fields">
        <div class="field">
          <input
            type="text"
            :class="['field__text', { 'field__text--error': badName }]"
            required
            v-model="name"
          /><label :class="['field__label', { 'field__label--error': badName }]"
            >{{ $t('experience.personal-data.name.label') }} *</label
          >
          <span v-if="badName" class="field--error">{{
            $t('experience.personal-data.name.error')
          }}</span>
        </div>
        <div class="field">
          <input
            type="tel"
            class="field__text"
            v-model="phone"
            required
          /><label
            :class="['field__label', { 'field__label--error': badPhone }]"
            >{{ $t('experience.personal-data.phone.label') }} *</label
          >
          <span v-if="badPhone" class="field--error">{{
            $t('experience.personal-data.phone.error')
          }}</span>
        </div>
        <div class="field">
          <input
            type="text"
            class="field__text"
            v-model="postCode"
            required
          /><label class="field__label">{{
            $t('experience.personal-data.post-code')
          }}</label>
        </div>
        <div class="field">
          <input
            type="text"
            :class="['field__text', { 'field__text--error': badEmail }]"
            v-model="email"
            required
          /><label
            :class="['field__label', { 'field__label--error': badEmail }]"
            >{{ $t('experience.personal-data.email.label') }} *</label
          >
          <span v-if="badEmail" class="field--error">{{
            $t('experience.personal-data.email.error')
          }}</span>
        </div>
      </div>
      <div class="check-terms">
        <div class="check_field">
          <label class="check client">
            <input type="checkbox" v-model="isClient" />
            <span class="checkmark"></span>
          </label>
          <div>{{ $t('experience.personal-data.client') }}</div>
        </div>
        <div class="check_field">
          <label class="check">
            <input type="checkbox" v-model="isPolicy" />
            <span class="checkmark"></span>
          </label>
          <div
            v-html="$t('experience.personal-data.policy')"
            @click="showNotice = true"
          ></div>
        </div>
      </div>
      <div class="form__action">
        <div
          :class="[
            'button-movistar',
            'button-movistar__primary',
            {
              'button-movistar__primary--disabled':
                !name || !phone || !email || !isPolicy
            }
          ]"
          @click="saveData"
        >
          <IconLoader2 v-if="isLoading" class="spinner-icon" />
          <span v-else>
            {{ $t('experience.personal-data.continue') }}
          </span>
        </div>
      </div>
    </div>

    <modal :showModal="showModal">
      <template #content>
        <div class="no-places">
          <div class="no-places__title">
            {{ $t(modalTitleKey) }}
          </div>
          <div class="no-places__subtitle">
            {{ $t(modalSubtitleKey) }}
          </div>
        </div>
        <div>
          <div class="no-places__action">
            <div
              class="button-movistar button-movistar__primary"
              @click="goToExperiences"
            >
              {{ $t('experience.personal-data.modal.button') }}
            </div>
          </div>
        </div>
      </template>
    </modal>

    <modal :showModal="showNotice">
      <template #content>
        <div class="no-places">
          <div
            class="no-places__title"
            v-html="$t('experience.personal-data.modal.notice.title')"
          ></div>
          <div
            class="no-places__subtitle"
            v-html="$t('experience.personal-data.modal.notice.subtitle')"
          ></div>
        </div>
        <div>
          <div class="no-places__action">
            <div
              class="button-movistar button-movistar__primary"
              @click="showNotice = false"
            >
              {{ $t('experience.personal-data.modal.button') }}
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script setup>
  import { IconLoader2 } from '@tabler/icons-vue'
   import IntroTitle from '@/components/movistar/common/IntroTitle.vue'
  import router from '@/router'
  import { ref, computed } from 'vue'
  import savePersonalData from '@/plugins/savePersonalData'
  import modal from '@/components/movistar/modals/Modal.vue'
  import { useStore } from 'vuex'

  const FingerprintJS = require('@fingerprintjs/fingerprintjs')
  const fpPromise = FingerprintJS.load()
  const store = useStore()

  const props = defineProps({
    audience: {
      type: String
    }
  })

  let name = ref(null)
  let phone = ref(null)
  let postCode = ref(null)
  let email = ref(null)
  let isLegalAge = ref(true)
  let isClient = ref(false)
  let isPolicy = ref(false)
  let badEmail = ref(false)
  let badPhone = ref(false)
  let badName = ref(false)
  let showModal = ref(false)
  let showNotice = ref(false)

  // Mensaje del modal de error segun el codigo de Debmedia (llega en el 409, campo message).
  // Fallback al generico ("no quedan plazas") para timeouts y codigos no mapeados.
  const GENERIC_T = 'experience.personal-data.modal.title'
  const GENERIC_S = 'experience.personal-data.modal.subtitle'
  let modalTitleKey = ref(GENERIC_T)
  let modalSubtitleKey = ref(GENERIC_S)
  const CODE_TO_KEY = {
    API_APPOINTMENTS_CREATE_MAX_NUMBER_OF_APPOINTMENTS_PER_CUSTOMER_PER_DAY_REACHED: 'maxPerDay',
    API_V2_APPOINTMENTS_MAX_OVERLAPPING_EXCEEDED: 'overlapping',
    // Se busca por subcadena, asi que este trozo vale igual para la clave
    // larga del proveedor y para la que mandamos nosotros.
    BLOCKED_BY_ATTENDANCE_POLICY: 'blocked',
    SLOTS_EXCEED_MAX: 'tooManySlots',
    ESPACIO_SLOT_TOO_LATE: 'tooLate',
    ESPACIO_SLOT_TOO_FAR_AHEAD: 'tooFarAhead',
    ESPACIO_BOOKING_NOT_OPEN: 'bookingNotOpen',
    ESPACIO_BOOKING_CLOSED: 'bookingClosed'
  }
  const setErrorModal = (error) => {
    const raw = String(error?.response?.data?.message ?? error?.message ?? '')
    let key = null
    for (const code in CODE_TO_KEY) if (raw.includes(code)) key = CODE_TO_KEY[code]
    if (!key && /timed?\s*out|timeout|read timed/i.test(raw)) key = 'timeout'
    modalTitleKey.value = key ? `experience.personal-data.modal.errors.${key}.title` : GENERIC_T
    modalSubtitleKey.value = key ? `experience.personal-data.modal.errors.${key}.subtitle` : GENERIC_S
  }
  let isLoading = ref(false)

  let experience = computed(() => store.getters['getExperience'])
  let slot = computed(() => store.getters['getSlot'])
  let fbToken = computed(() => store.state.session.fbToken)
  let storeId = computed(() => store.getters['getStoreId'])

  const saveData = async () => {
    badEmail.value = false
    badPhone.value = false
    badName.value = false
    if (name.value && phone.value && email.value && isPolicy.value) {
      let error = false
      if (!validateEmail(email.value)) {
        badEmail.value = true
        error = true
      }

      if (!validatePhone(phone.value)) {
        badPhone.value = true
        error = true
      }

      if (!validateName(name.value)) {
        badName.value = true
        error = true
      }

      if (error) {
        return
      }

      // Get the visitor identifier when you need it.
      const fp = await fpPromise
      const result = await fp.get()

      if (!isLoading.value) {
        if (experience.value.schedule) {
          try {
            isLoading.value = true
            const appointment = await savePersonalData({
              experienceCode: experience.value.code,
              scheduleId: experience.value.schedule?.id,
              branchId: experience.value.schedule?.branchId,
              storeId: storeId.value,
              slot: slot?.value,
              audience: props.audience,
              name: name.value,
              phone: phone.value,
              postCode: postCode.value,
              email: email.value,
              isLegalAge: isLegalAge.value,
              isClient: isClient.value,
              isPolicy: isPolicy.value,
              token: fbToken.value,
              clientCode: result.visitorId
            })

            store.commit('setAppointment', appointment)

            router.push({
              name: 'Booking',
              params: { audience: props.audience }
            })
          } catch (error) {
            setErrorModal(error)
            showModal.value = true
          } finally {
            isLoading.value = false
          }
        } else {
          try {
            isLoading.value = true
            await store.dispatch('createExperienceTurn', {
              experienceCode: experience.value.code,
              name: name.value,
              phone: phone.value,
              postCode: postCode.value,
              email: email.value,
              isLegalAge: isLegalAge.value,
              isClient: isClient.value,
              policyAccept: isPolicy.value,
              token: fbToken.value,
              clientCode: result.visitorId,
              storeId: storeId.value
            })

            router.push({ name: 'Turn' })
          } catch (error) {
            setErrorModal(error)
            showModal.value = true
          } finally {
            isLoading.value = false
          }
        }
      }
    }
  }

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  const validatePhone = (phone) => {
    return String(phone)
      .toLowerCase()
      .match(/^(?:(?:\+?[0-9]{2,4})?[ ]?[6789][0-9 ]{8,13})$/)
  }

  //Solo letras y espacios, ya que el servicio externo no admite números, signos...
  const validateName = (name) => {
    return String(name)
      .toLowerCase()
      .match(/^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g)
  }

  const goToExperiences = () => {
    showModal.value = false
    router.push({
      name: 'ExperienceTypes'
    })
  }
</script>
<style lang="scss">
  @import '@/scss/mixings';
  .head {
    @include d-flex(row, space-between, center, 0px);
    padding: 10px 15px;

    &__back {
      @include d-flex(row, flex-start, center, 10px);
      padding: 1px;
      text-align: center;
      font-size: var(--fs-small);
      font-weight: var(--fw-medium);
      & img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .form {
    @include d-flex(column, flex-start, center, 35px);
    padding: 10px 30px;
    flex: 1 1 0;
    .fields {
      @include d-flex(column, flex-start, flex-start, 30px);
      width: 100%;
      @media screen and (min-width: $md-breakpoint) {
        display: grid;
        grid-template-columns: repeat(2, 1fr); 
        gap: 20px;
      }
      .field {
        @include d-flex(column, flex-start, flex-start, 4px);

        width: 100%;
        position: relative;

        & input[type='text'],
        input[type='tel'],
        input[type='email'] {
          width: 100%;
          height: 56px;
          padding: 22px 12px 8px;
          border-radius: 8px;
          border: 1px #dddddd solid;
          box-sizing: border-box;
          line-height: 24px;
          font-size: var(--fs-medium);

          &:focus-visible {
            outline: none;
          }

          &:focus ~ label,
          &:not(:focus):valid ~ label {
            top: 8px;
            bottom: 10px;
            left: 12px;
            font-size: var(--fs-x-small);
            line-height: var(--fs-medium);
            opacity: 1;
            color: var(--primary-40-color);

            &.field__label--error {
              color: #ff374a;
            }
          }
        }

        & label {
          position: absolute;
          pointer-events: none;
          left: 12px;
          top: 18px;
          transition: 0.2s ease all;
        }

        &--error {
          color: #ff374a;
          font-size: var(--fs-x-small);
          line-height: 1rem;
          word-wrap: break-word;
          padding-left: 12px;
        }
      }
    }
    .check-terms{
      display: grid;
      grid-template-columns: repeat(1, 1fr); 
      width: 100%;
      gap: 25px;
      @media screen and (min-width: $md-breakpoint) {
        grid-template-columns: repeat(2, 1fr); 
      }
    }
    .check_field {
      @include d-flex(row, flex-start, initial, 15px);

      .check {
        align-self: baseline;
        display: block;
        position: relative;
        height: auto;
        width: 24px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        &.client {
          width: 45px;
          @media screen and (min-width: $lg-breakpoint) {
            width: 25px;
          }
        }

        & input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;
        }

        /* Create a custom checkbox */
        .checkmark {
          position: absolute;
          top: 0;
          left: 0;
          height: 20px;
          width: 20px;
          background-color: white;
          border-radius: 1px;
          border: 1.5px #232323 solid;
        }

        /* On mouse-over, add a grey background color */
        &:hover input ~ .checkmark {
          background-color: white;
        }

        /* When the checkbox is checked, add a blue background */
        & input:checked ~ .checkmark {
          background-color: var(--primary-40-color);
        }

        /* Create the checkmark/indicator (hidden when not checked) */
        .checkmark:after {
          content: '';
          position: absolute;
          display: none;
        }

        /* Show the checkmark when checked */
        & input:checked ~ .checkmark:after {
          display: block;
        }

        /* Style the checkmark/indicator */
        & .checkmark:after {
          left: 7px;
          top: 3px;
          width: 5px;
          height: 10px;
          border: solid white;
          border-width: 0 2px 2px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }
      }
    }
    &__action{
      @include d-flex(row, flex-start, center);
      width: 100%;
      @media screen and (min-width: $md-breakpoint) {
        @include d-flex(row, center, center);
      }
    }
    @media screen and (min-width: $md-breakpoint) {
      padding: 20px 50px 50px 50px;
    }
  }

  .no-places {
    @include d-flex(column, flex-start, flex-start, 8px);
    line-height: 24px;

    &__title {
      font-weight: var(--fw-bold);
    }

    &__subtitle {
      font-size: var(--fs-small);
      word-wrap: break-word;
      color: var(--secondary-color);

      & a {
        color: var(--primary-40-color);
      }
    }

    &__action {
      padding: 16.11px 0px;
    }
  }
</style>
